/* tslint:disable */
/* eslint-disable */
/**
 * TOM BILLING SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CarrierVisitDto } from '../model';
// @ts-ignore
import type { TruckVisitOrderDto } from '../model';
// @ts-ignore
import type { TruckVisitSignaturesDto } from '../model';
/**
 * CarrierVisitsApi - axios parameter creator
 */
export const CarrierVisitsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [truckVisitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTruckVisitOrders: async (truckVisitId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/CarrierVisits/getTruckVisitOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (truckVisitId !== undefined) {
                localVarQueryParameter['TruckVisitId'] = truckVisitId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [truckVisitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTruckVisitSignatures: async (truckVisitId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/CarrierVisits/getTruckVisitSignatures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (truckVisitId !== undefined) {
                localVarQueryParameter['TruckVisitId'] = truckVisitId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [notDepartedVisit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTruckVisits: async (notDepartedVisit?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/CarrierVisits/getTruckVisits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (notDepartedVisit !== undefined) {
                localVarQueryParameter['NotDepartedVisit'] = notDepartedVisit;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [onlyDepartedVisit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselVisits: async (onlyDepartedVisit?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billingService/api/CarrierVisits/getVesselVisits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (onlyDepartedVisit !== undefined) {
                localVarQueryParameter['OnlyDepartedVisit'] = onlyDepartedVisit;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CarrierVisitsApi - functional programming interface
 */
export const CarrierVisitsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CarrierVisitsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [truckVisitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTruckVisitOrders(truckVisitId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TruckVisitOrderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTruckVisitOrders(truckVisitId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarrierVisitsApi.getTruckVisitOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [truckVisitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTruckVisitSignatures(truckVisitId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TruckVisitSignaturesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTruckVisitSignatures(truckVisitId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarrierVisitsApi.getTruckVisitSignatures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [notDepartedVisit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTruckVisits(notDepartedVisit?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CarrierVisitDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTruckVisits(notDepartedVisit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarrierVisitsApi.getTruckVisits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [onlyDepartedVisit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselVisits(onlyDepartedVisit?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CarrierVisitDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselVisits(onlyDepartedVisit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarrierVisitsApi.getVesselVisits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CarrierVisitsApi - factory interface
 */
export const CarrierVisitsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CarrierVisitsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [truckVisitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTruckVisitOrders(truckVisitId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<TruckVisitOrderDto>> {
            return localVarFp.getTruckVisitOrders(truckVisitId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [truckVisitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTruckVisitSignatures(truckVisitId?: number, options?: RawAxiosRequestConfig): AxiosPromise<TruckVisitSignaturesDto> {
            return localVarFp.getTruckVisitSignatures(truckVisitId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [notDepartedVisit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTruckVisits(notDepartedVisit?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<CarrierVisitDto>> {
            return localVarFp.getTruckVisits(notDepartedVisit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [onlyDepartedVisit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselVisits(onlyDepartedVisit?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<CarrierVisitDto>> {
            return localVarFp.getVesselVisits(onlyDepartedVisit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CarrierVisitsApi - object-oriented interface
 */
export class CarrierVisitsApi extends BaseAPI {
    /**
     * 
     * @param {number} [truckVisitId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTruckVisitOrders(truckVisitId?: number, options?: RawAxiosRequestConfig) {
        return CarrierVisitsApiFp(this.configuration).getTruckVisitOrders(truckVisitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [truckVisitId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTruckVisitSignatures(truckVisitId?: number, options?: RawAxiosRequestConfig) {
        return CarrierVisitsApiFp(this.configuration).getTruckVisitSignatures(truckVisitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [notDepartedVisit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTruckVisits(notDepartedVisit?: boolean, options?: RawAxiosRequestConfig) {
        return CarrierVisitsApiFp(this.configuration).getTruckVisits(notDepartedVisit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [onlyDepartedVisit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselVisits(onlyDepartedVisit?: boolean, options?: RawAxiosRequestConfig) {
        return CarrierVisitsApiFp(this.configuration).getVesselVisits(onlyDepartedVisit, options).then((request) => request(this.axios, this.basePath));
    }
}

